<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/20CH/20CH.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">20CH DSP Amplifier</div>
                <div class="detail-banner-desc">
                    The 20-channel amplifier builds upon the 12-channel platform with further performance upgrades: It supports A2B Booster connection for channel expansion. Features tracking power supply technology (TPS), improving efficiency by around 30% and reducing heat output;<br />
                    For audio features, it adds support for 3D virtual surround, 4D cinema mode, 7.1.4 immersive audio, road active noise control (RNAC), virtual scenes, and headrest surround sound.
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction</div>
                    <div class="detail-desc">
                        <div>
                            Self developed, complete R&D team, mature and reliable SOP solutions.
                        </div>
                        <div>
                            1220W rated output power, 20CH audio outputs, drive up to 27 speakers.
                        </div>
                        <div>
                            High computing power, premium audio processing.
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/20CH/20CH-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">236*148*42</div>
                                    <div class="k">Size(mm)</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1405</div>
                                    <div class="k">Weight(g)</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1220W</div>
                                    <div class="k">Rated Power</div>
                                </div> 
                                <div class="spec-item">
                                    <div class="v">&gt90dB</div>
                                    <div class="k">SNR</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">&lt0.03%</div>
                                    <div class="k">THD+N</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">Amor Space® virtual scene</div>
                                    <div class="k">Audio Function</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Stereo sound, Amor TruLogic® 2D & 3D surround, multiple sound mode experiences, Amor Pano® 7.1.4 Atmos sound</div>
                                    <div class="k">Audio Function</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/20CH/20CH-1.jpg" alt="200-1-02">
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/20CH/20CH-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">Amor Max Immersion®4D seat rhythm</div>
                                    <div class="k">Audio Function</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">iESE simulates sound waves, ENAC engine noise reduction, RNAC road noise control, and DNC dynamic speed compensation</div>
                                    <div class="k">Audio Function</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
  title: '20CH DSP Amplifier - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/electronics/20CH.html'

};

import { createApp } from 'vue';
import App from './20CH.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./20CH.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
